export default function formatPercentage(percentage, decimals, withSymbol) {
  let valuePercentage = !percentage ? 0 : percentage;
  const valueDecimals = !decimals ? 2 : decimals;
  const valueWithSymbol = (withSymbol === undefined || withSymbol === null) ? true : withSymbol;

  valuePercentage *= 100;
  valuePercentage = Math.round(valuePercentage * (10 ** valueDecimals)) / (10 ** valueDecimals);
  valuePercentage = valueWithSymbol ? `${valuePercentage}%` : valuePercentage;
  return valuePercentage;
}
